import { request } from '../request';

export const uploadFile = async (data: { path: string; file: File; overwriteFile: boolean }) => {
  const response = await request.postForm(`v1/files/upload/`, data);
  return response.data;
};

export const getUploadedFileUrl = async (path: string) => {
  const response = await request.get<{ url: string }>(`v1/files/uploaded/?path=${path}`);
  return response.data;
};
